import { render, staticRenderFns } from "./create-product-wizard.vue?vue&type=template&id=309bb34a&scoped=true&"
import script from "./create-product-wizard.vue?vue&type=script&lang=js&"
export * from "./create-product-wizard.vue?vue&type=script&lang=js&"
import style0 from "./create-product-wizard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./create-product-wizard.vue?vue&type=style&index=1&id=309bb34a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309bb34a",
  null
  
)

export default component.exports